"use client";

import { Link } from "@/components/common/Link";
import { Upload } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function UploadPhotographs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="subirfotografias" ref={ref} className="relative py-16 md:py-24 bg-primary-light overflow-hidden">
      <div className="container relative z-10">
        <div className={`max-w-3xl mx-auto transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="text-center mb-10">
            <h2 className="font-display text-[2.125rem] font-semibold text-foreground mb-4">
              Subir Fotografías
            </h2>
            <div className="text-base text-muted-foreground leading-relaxed max-w-2xl mx-auto space-y-4">
              <p>
                Si has hecho fotos o vídeos durante la boda, nos encantaría que los compartieras con nosotros.
              </p>
              <p>
                Queremos crear un álbum digital con todos esos momentos especiales vistos desde vuestros ojos.
              </p>
              <p>
                Cada imagen cuenta una parte del día y nos hará muchísima ilusión poder revivirlo también a través de ellas.
              </p>
            </div>
          </div>

          <Link to="https://www.dropbox.com/request/Y0NNdnPQ80h5BDj3F0k2" newTab className="block">
            <div className="bg-background rounded-[var(--radius-lg)] shadow-medium p-8 md:p-12 hover:-translate-y-2 hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] cursor-pointer group relative overflow-hidden">
              <div className="relative z-10 flex flex-col items-center text-center space-y-6">
                <div className="inline-flex items-center justify-center w-24 h-24 md:w-32 md:h-32 bg-primary/10 rounded-full group-hover:bg-primary/20 group-hover:scale-110 transition-all duration-[var(--duration-medium)]">
                  <Upload className="size-12 md:size-16 text-primary-dark group-hover:text-primary-dark transition-colors" />
                </div>

                <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground group-hover:text-foreground transition-colors">
                  Haz clic aquí para subir tus fotos
                </h3>

                <p className="text-base text-muted-foreground max-w-md leading-relaxed">
                  Serás redirigido a nuestra carpeta segura de Dropbox donde podrás cargar todas tus fotografías de la boda. Acepta múltiples archivos y formatos de imagen.
                </p>

                <div className="flex items-center gap-2 text-sm text-foreground font-medium group-hover:gap-3 transition-all">
                  <span>Abrir Dropbox</span>
                  <svg className="size-4 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                  </svg>
                </div>
              </div>
            </div>
          </Link>

          <div className="mt-6 text-center">
            <p className="text-sm text-muted-foreground">
              ¿Tienes problemas? Contacta con nosotros en la sección de{" "}
              <Link to="/#contactos-de-emergencia" className="text-foreground hover:underline font-medium">
                Contacto
              </Link>
            </p>
          </div>
        </div>
      </div>
    </section>;
}